<script>
import Vue from 'vue'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
import BodyMen from '../home/bodyMen'
import BoardVisorEvents from './boardVisorEvents'
import BoardVisorSmallEvents from './boardVisorSmallEvents'

// import BoardVisorSmall from '../game/boardVisorSmall'
// import UploadFiles from './uploadFiles'
// import BodyMen from './bodyMen'
import Jquery from 'jquery'
import toast from 'vue-material-components'

var intervalTorneos1 = null
var boardname = ''
// var oReqTorneo = new window.XMLHttpRequest()
var lastDateTorneo1 = new Date(new Date().setDate(new Date().getDate() - 1))
var lastDateTorneo2 = new Date(new Date().setDate(new Date().getDate() - 1))
var lastDateTorneo3 = new Date(new Date().setDate(new Date().getDate() - 1))
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
export default {
  route: {
    canActivate: function (transition) {
      return UserService.user_acces('authenticate') ? true : transition.redirect('user/loguin')
    }
  },
  template: require('./template.html'),
  data () {
    return {
      finduser: '',
      sendToAll: true,
      dirActionUpload: Store.get('serverDir') + '/chat/upload',
      dirServer: Store.get('serverDir'),
      filesUpload: [],
      hashFileBoard1: '0000000',
      hashFileBoard2: '0000000',
      hashFileBoard3: '0000000',
      fileProgress: 0,
      allFilesUploaded: true,
      offcanvas: false,
      active: 'boardVisorEvents',
      activeChat: 'Visor',
      chatRecibido: false,
      tab: '0',
      tabs: [],
      chattext: '',
      newEmoji: '',
      user: UserService.user,
      boards: [],
      boardFiles: [],
      boardFilesName: '',
      boardFiles2: [],
      boardFilesName2: '',
      boardFiles3: [],
      boardFilesName3: '',
      pgnFingerprints: {
        boardFiles: {},
        boardFiles2: {},
        boardFiles3: {}
      },
      newboard: {
        color: 'w',
        time: '3',
        contrincante: '',
        public: true,
        broadcast: false
      },
      userconvert: Store.get('userconvert', {}),
      mensjGame: [],
      users: [],
      usersLength: 0,
      games: [],
      board: Store.get('boardSeeEvents', {}),
      srcVideo1: '',
      srcVideo2: '',
      srcVideo3: '',
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      classBoard: '',
      boardname: 'none',
      iFrameSrc: Store.get(boardname) && Store.get('url' + Store.get(boardname)._id) ? Store.get('url' + Store.get(boardname)._id) : ''
    }
  },
  mixins: [
    toast
  ],
  events: {
    users (data) {
      this.users = data.nicknames
    },
    boards (data) {
      this.boards = data.boards
    },
    mensaje (data) {
      if (data.send !== this.user.username) {
        this.recibeMensaje(data.men, true, false)
        if (data.men.send !== this.user.username) {
          this.chatRecibido = true
        }
      }
    },
    onFileClick (file) {
      // console.log('onFileClick', file)
    },
    onFileChange (file) {
      // console.log('onFileChange', file)
      // here is where we update our view
      this.fileProgress = 0
      this.allFilesUploaded = false
    },
    beforeFileUpload (file) {
      // called when the upload handler is called
      // console.log('beforeFileUpload', file)
      this.toast('<span>' + 'Cargando imagen' + '</span>', 2000)
    },
    afterFileUpload (file) {
      // called after the xhr.send() at the end of the upload handler
      // console.log('afterFileUpload', file)
      this.toast('<span>' + Vue.t('home.uploadMens.success') + '</span>', 2000)
    },
    onFileProgress (progress) {
      // console.log('onFileProgress', progress)
      // update our progress bar
      this.fileProgress = parseInt(progress.percent)
    },
    onFileUpload (file, res) {
      // console.log('onFileUpload', file, res)
      this.chattext = {
        name: file.name,
        size: file.size,
        type: file.type,
        lastModifiedDate: file.lastModifiedDate
      }
      this.sendMensaje('file')
    },
    onFileError (file, res) {
      this.toast('<span>Error ' + res + '</span>', 3000)
      // console.error('onFileError', file, res)
    },
    onAllFilesUploaded (files) {
      // console.log('onAllFilesUploaded', files)
      this.toast('<span>' + Vue.t('home.uploadMens.success') + '</span>', 2000)
      // everything is done!
      this.allFilesUploaded = true
    },
    updateBoards (classBoard) {
      this.classBoard = classBoard
    },
    mensajeUrl (data) {
      if (data.men.src.length <= 0) {
        this.iFrameSrc = ''
      } else {
        var initUser = data.men.src.indexOf('usuario=') + 8
        var finUser = data.men.src.indexOf('&', initUser)
        var userOld = data.men.src.substring(initUser, finUser)
        var src = data.men.src
        if (initUser > 0 && finUser > 0) {
          src = data.men.src.replace(userOld, this.user.username)
        }
        var actual = Store.get(boardname) && Store.get('url' + Store.get(boardname)._id) ? Store.get('url' + Store.get(boardname)._id) : ''
        this.iFrameSrc = src
        if (actual !== data.men.src && data.men.id === Store.get(boardname)._id) {
          Store.set('url' + data.men.id, data.men.src)
          this.iFrameSrc = src
        }
      }
    }
  },
  props: {},
  computed: {},
  components: {
    BoardVisorEvents,
    // UploadFiles,
    BodyMen,
    BoardVisorSmallEvents
    // BoardVisorSmall
  },
  watch: {
    inmediate: true,
    newEmoji (newVal, oldVal) {
      this.chattext += newVal
      document.getElementById('textChatInput').focus()
    },
    activeChat (newVal, oldVal) {
      if (newVal === 'Visor') {
        this.showBoard(this.board)
        this.chatRecibido = false
      }
      if (this.activeChat === 'Chat') {
        this.chatRecibido = false
        // this.scrollBottom()
      }
    },
    myFENValue (val, oldVal) {
      // window.alert(' myFENValue: ' + val)
      document.getElementById('myFENValueP').textContent = val
      if (document.getElementById('searchInput')) {
        // document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
        document.getElementById('searchInput').value = val
        document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
      }
    }
  },
  methods: {
    getLength (param) {
      var ret = 0
      if (param !== undefined && Object.keys(param) !== undefined) {
        ret = Object.keys(param).length
      }
      return ret
    },
    /* imageUrl (name) {
      return this.dirServer + '/uploads/' + name
    },*/
    userScroll (e) {
      var scrollTop = e.target.scrollTop
      // var scrollWidth = e.target.scrollWidth
      // var scrollHeight = e.target.scrollHeight
      // var clientHeight = e.target.clientHeight
      // console.log(scrollTop, scrollWidth, scrollHeight, clientHeight)
      if (scrollTop === 0) {
        var post = this.foundTab(this.active)
        // console.log('cargar historial anterior', this.active)
        var parmsLoad = {
          user: this.active,
          board: 'Retransmisión',
          range: {
            limit: 100,
            skip: this.tabs[post].men.length
          }
        }
        this.loadUserConvert(parmsLoad, true)
      }
    },
    /* isAtBottom () {
      if (this.active === 'boardVisorEvents') {
        return
      }
      var tabConvert = document.getElementById('content_' + this.active)
      if (tabConvert) {
        var atBottom = tabConvert.scrollTop >= tabConvert.scrollHeight - tabConvert.clientHeight
        if (atBottom) {
          this.scrollBottom()
        }
      }
    },*/
    /* scrollBottom () {
      Jquery('#content_' + this.active).animate({
        'scrollTop': Jquery('#content_' + this.active)[0].scrollHeight
      }, 'slow')
    },*/
    getTorneo1 (onlyNames = false) {
      if (this.getTorneos(1) === true) {
        this.getHeadersFile('../../../static/torneos/live1.pgn', 1, onlyNames)
        this.$broadcast('modal::open', 'pgnFilesModal')
      }
    },
    getTorneo2 (onlyNames = false) {
      if (this.getTorneos(2) === true) {
        this.getHeadersFile('../../../static/torneos/live2.pgn', 2, onlyNames)
        this.$broadcast('modal::open', 'pgnFilesModal')
      }
    },
    getTorneo3 (onlyNames = false) {
      if (this.getTorneos(3) === true) {
        this.getHeadersFile('../../../static/torneos/live3.pgn', 3, onlyNames)
        this.$broadcast('modal::open', 'pgnFilesModal')
      }
    },
    toogleOfCanvas () {
      this.offcanvas = !this.offcanvas
    },
    isOwner () {
      return this.user.username === this.board.u1 || this.user.username === this.board.u2
    },
    getHeadersFile (strFile, number, onlyNames = false) {
      var _self = this
      var oReq = new window.XMLHttpRequest()
      oReq.open('GET', strFile, true) // ../../../static/live.pgn', true)
      // oReq.setRequestHeader('Access-Control-Allow-Origin', '*')
      /* if (number === 1 && lastDateTorneo1 !== null) {
        oReq.setRequestHeader('If-Modified-Since', lastDateTorneo1.toString())
      } else if (number === 2 && lastDateTorneo2 !== null) {
        oReq.setRequestHeader('If-Modified-Since', lastDateTorneo2.toString())
      } else if (number === 3 && lastDateTorneo3 !== null) {
        oReq.setRequestHeader('If-Modified-Since', lastDateTorneo3.toString())
      }*/
      oReq.onreadystatechange = function () {
        if (oReq.readyState === 4) {
          if (oReq.status === 200) {
            var fileStr = this.responseText
            // var hashFile = _self.hashCode(_self.generateHeader(this.responseText, true))
            // var hashFile = _self.hashCode(this.responseText)
            var mtime = new Date(oReq.getResponseHeader('Last-Modified'))
            if (number === 1 && mtime > _self.lastDateTorneo1) {
              _self.lastDateTorneo1 = mtime
              if (onlyNames === false) {
                _self.parsePgnFiles(fileStr, true, number)
              } else {
                _self.boardFilesName = _self.generateHeader(fileStr, false)
                _self.activeBoardName = _self.boardFilesName
              }
            } else if (number === 2 && mtime > _self.lastDateTorneo2) {
              _self.lastDateTorneo2 = mtime
              if (onlyNames === false) {
                _self.parsePgnFiles(fileStr, true, number)
              } else {
                _self.boardFilesName2 = _self.generateHeader(fileStr, false)
                _self.activeBoardName = _self.boardFilesName2
              }
            } else if (number === 3 && mtime > _self.lastDateTorneo3) {
              _self.lastDateTorneo3 = mtime
              if (onlyNames === false) {
                _self.parsePgnFiles(fileStr, true, number)
              } else {
                _self.boardFilesName3 = _self.generateHeader(fileStr, false)
                _self.activeBoardName = _self.boardFilesName3
              }
            }
          }
        }
      }
      oReq.send()
    },
    OpenTorneo (number) {
      const url = `../../../static/torneos/livelink${number}.txt`
      fetch(url)
        .then(response => {
          if (!response.ok) {
            // console.error(`Error ${response.status}: ${response.statusText}`)
            return
          }
          return response.text()
        })
        .then(responseText => {
          if (responseText) {
            let handler = window.open(responseText)
            if (handler) {
              handler.focus()
              if (window.opener !== null) {
                setTimeout(() => {
                  window.opener.focus()
                }, 3000)
              }
            }
          }
        })
        .catch(error => {
          console.error('Fetch error:', error)
        })
    },
    /* OpenTorneo (number) {
      var oReq = new window.XMLHttpRequest()
      oReq.open('GET', '../../../static/torneos/livelink' + number + '.txt', true) // ../../../static/live.pgn', true)
      // oReq.setRequestHeader('Access-Control-Allow-Origin', '*')
      oReq.onreadystatechange = function () {
        if (oReq.readyState === 4) {
          if (oReq.status === 200) {
            // window.alert(this.responseText)
            let handler = window.open(this.responseText)
            handler.focus()
            if (window.opener !== null) {
              setTimeout(window.opener.focus(), 3000)
            }
          }
        }
      }
      oReq.send()
    },*/
    ShowTorneo (idTorneo) {
      var x1 = document.getElementById('idTorneo1')
      if (x1 !== undefined && x1 !== null) {
        x1.style.display = 'none'
      }
      var x2 = document.getElementById('idTorneo2')
      if (x2 !== undefined && x2 !== null) {
        x2.style.display = 'none'
      }
      var x3 = document.getElementById('idTorneo3')
      if (x3 !== undefined && x3 !== null) {
        x3.style.display = 'none'
      }
      var x = document.getElementById(idTorneo)
      if (x !== undefined && x !== null) {
        if (x.style.display === 'none') {
          x.style.display = 'flex'
        } else {
          x.style.display = 'none'
        }
      }
      document.body.dispatchEvent(new window.Event('chessground.resize'))
      /* const video = document.getElementById('video')
      const button = document.getElementById('button')

      button.addEventListener('click', function () {
        button.disabled = true
        try {
          if (document.pictureInPictureElement === video) {
            document.exitPictureInPicture()
            button.innerText = 'Activar PIP'
          } else {
            video.requestPictureInPicture()
            button.innerText = 'Desactivar PIP'
          }
        } catch (error) {
          console.log('Ocurrión un error: ${error}')
        } finally {
          // Habilitamos el botón después del evento.
          button.disabled = false
        }
      })
      video.addEventListener('enterpictureinpicture', function (event) {
        console.log(event)
      })
      video.addEventListener('leavepictureinpicture', function (event) {
        console.log(event)
      })*/
      // this.$broadcast('modal::open', 'clasificacion1')
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        // window.alert('[k' + key + '] [' + value + ']')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    isHumanVsPC () {
      return (this.board !== undefined && (this.board.u1 === 'PC') || (this.board.u2 === 'PC'))
    },
    isHumanVsAnalisis () {
      return (this.board !== undefined && this.board.u1 === this.board.u2)
    },
    imagePersona (persona) {
      // Convierte el nombre a minúsculas
      var name = persona.toLowerCase()
      // Encuentra la primera coma y el primer espacio en blanco
      var commaIndex = name.indexOf(',')
      var spaceIndex = name.indexOf(' ')
      // Determina cuál índice usar (el menor de los dos, si ambos existen)
      var cutIndex = commaIndex > -1 ? commaIndex : spaceIndex
      cutIndex = (cutIndex > -1 && spaceIndex > -1) ? Math.min(commaIndex, spaceIndex) : cutIndex
      // Corta el nombre usando el índice determinado
      if (cutIndex > -1) {
        name = name.substring(0, cutIndex)
      }
      var ret = ''
      try {
        ret = require('../../../static/images/personas/' + name + '.jpg')
        ret = '../../../static/images/personas/' + name + '.jpg'
      } catch (e) {
        ret = '../../../static/images/personas/default.png'
      }
      return ret
    },
    generateHeader (pgnFile, complete = true, onlyNames = false) {
      var retHeader = ''
      // var pgnInLines = pgnFile.split('"]').join('"]\n')
      var headers = this.parse_pgn_header(pgnFile)
      if (headers !== undefined && headers['Event'] !== undefined) {
        var appendHeader = function (result, headers, separator) {
          if (headers && headers.length > 0) {
            if (result.length > 0) {
              result += separator
            }
            result += headers
          }
          return result
        }
        var hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date']] // , headers['ECO'], headers['Result']]
        if (complete) {
          retHeader = '' + headers['White'] + ' vs ' + headers['Black']
          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']]
        }
        if (onlyNames) {
          if (headers['Round'] !== undefined) {
            retHeader += headers['Round'] + ' ' + headers['White'] + ' vs ' + headers['Black']
          } else {
            retHeader += headers['White'] + ' vs ' + headers['Black']
          }
          if (headers['Result'] !== '*') {
            retHeader += ' [' + headers['Result'] + ']'
          }
          hh = []
        }
        if (hh.length > 1) {
          var rest = ''
          retHeader += ' ('
          hh.forEach(function (headers) {
            rest = appendHeader(rest, headers, ' | ')
          })
          retHeader += rest
          retHeader += ')'
        }
        // window.alert(retHeader)
      }
      // retHeader = decodeURIComponent(escape(retHeader))
      return retHeader
    },
    openTab (user, active = true) {
      // clearTimeout(window.computerGame)
      var tabConvert = {
        name: user.nickname,
        idTab: user.nickname,
        men: []
      }
      if (!this.foundTab(tabConvert.idTab)) {
        this.tabs.push(tabConvert)
        /* var parmsLoad = {
          user: tabConvert.idTab,
          board: 'Retransmisión',
          range: {
            limit: 100,
            skip: 0
          }
        }*/
        // window.alert('opentab')
        // this.loadUserConvert(parmsLoad)
      }
      if (active) {
        this.active = tabConvert.idTab
      }
    },
    foundTab (tab) {
      for (var i in this.tabs) {
        if (this.tabs[i].idTab === tab) {
          return i
        }
      }
      return false
    },
    closeTab (tab) {
      var post = this.foundTab(tab)
      this.tabs.splice(post, 1)
      if (this.tabs.length === 0) {
        this.active = 'boardVisorEvents'
      } else {
        if (this.active === this.tabs[this.tabs.length - 1].idTab) {
          this.active = 'nnn'
        }
        setTimeout(function () {
          this.active = this.tabs[this.tabs.length - 1].idTab
        }.bind(this), 200)
      }
      var data = {
        c: 'chat',
        f: 'removeConversation',
        data: {
          user: UserService.getUser().username,
          conver: tab
        }
      }
      this.$socket.emit('event', data, function (...callbacks) {
        // console.log('conversacion cerrada')
      })
    },
    clone (obj) {
      var dupe = (obj instanceof Array) ? [] : {}
      for (var property in obj) {
        if (typeof property === 'object') {
          dupe[property] = this.clone(obj[property])
        } else {
          dupe[property] = obj[property]
        }
      }
      return dupe
    },
    getBoardSnapshot (boardParam) {
      if (!boardParam || !boardParam._id) {
        return boardParam
      }

      const collections = [this.boardFiles, this.boardFiles2, this.boardFiles3, this.boards]
      for (let i = 0; i < collections.length; i++) {
        const pool = collections[i]
        if (Array.isArray(pool)) {
          const match = pool.find((item) => item && item._id === boardParam._id)
          if (match) {
            return match
          }
        }
      }

      return boardParam
    },
    showBoard (boardParam, bSame = false) {
      if (boardParam !== undefined && (bSame === false || (this.board && boardParam._id === this.board._id))) {
        // this.board._id = 0
        const latestBoard = this.getBoardSnapshot(boardParam)
        const clonedBoard = this.clone(latestBoard)
        const storedBoard = Store.set('boardSeeEvents', clonedBoard) || clonedBoard
        this.board = storedBoard
        this.active = 'boardVisorEvents'
        // console.log(this.active)
      }
    },
    desactiveBoard () {
      // window.alert('desactiveBoard')
      this.board = {}
      setTimeout(function () {
        this.active = 'boardVisorEvents'
      }.bind(this), 100)
    },
    sendMensaje () {
      if (this.chattext === '') {
        return
      }
      var thisUser = this.user.username
      var otherUser = this.board.u1 === thisUser ? this.board.u2 : this.board.u1
      if (this.userconvert.username || this.userconvert.nickname) {
        otherUser = this.userconvert.username || this.userconvert.nickname
      }
      if (otherUser === 'PC') {
        return
      }
      // window.alert(this.board.all)
      var men = {
        body: this.chattext,
        type: 'text',
        public: this.sendToAll,
        all: this.board.all,
        club: this.user.club,
        board: 'Retransmisión', // this.board._id,
        send: thisUser,
        recibe: thisUser
      }
      var data = {
        c: 'chat',
        f: 'mensaje',
        data: {
          men: men
        }
      }
      // window.alert(JSON.stringify(men))
      this.$socket.emit('event', data, function (...callbacks) {
        // console.log(callbacks)
      })
      this.chattext = ''
      this.isAtBottom()
    },
    /* sendMensaje (type = 'text') {
      if (type === 'text') {
        if (this.chattext.trim() === '') {
          this.chattext = ''
          return
        }
      }
      // window.alert(this.sendToAll)
      var post = this.foundTab(this.active)
      var men = {
        body: this.chattext,
        type: type,
        public: this.sendToAll,
        club: this.user.club,
        board: this.board._id,
        send: UserService.getUser().username,
        recibe: this.tabs[post].idTab
      }
      var data = {
        c: 'chat',
        f: 'mensaje',
        data: {
          men: men
        }
      }
      this.$socket.emit('event', data, function (...callbacks) {
        // console.log(callbacks)
      })
      this.chattext = ''
    },*/
    userToSentTo (user, toSend) {
      UserService.get(this, user.nickname).then(function (response) {
        const dd = JSON.parse(response)
        const somedata = dd
        // window.alert(somedata.username + toSend)
        somedata.sendtoanalyse = toSend
        this.usersSendTo = somedata
        this.$nextTick(function () {
          this.sendSendActivate(somedata)
        })
        // this.$broadcast('modal::close', 'some', 'usersSendTo')
      }, function (response) {
      })
    },
    userToConversation (user) {
      this.userconvert = user
      this.$broadcast('modal::close', 'some', 'usersConnect')
    },
    isAtBottom () {
      var chatConvert = document.getElementById('chatConvertGame')
      if (chatConvert) {
        this.scrollBottom()
      }
    },
    scrollBottom () {
      if (Jquery('#chatConvertGame')) {
        Jquery('#chatConvertGame').animate({
          'scrollTop': Jquery('#chatConvertGame')[0].scrollHeight
        }, 'fast')
      }
    },
    recibeMensaje (men, bottom = false, toast = true) {
      // var idDiv = 'chatConvertGame'
      // var divScroll = document.getElementById(idDiv)
      // var atBottom = divScroll.scrollTop >= divScroll.scrollHeight - divScroll.clientHeight
      // window.alert(JSON.stringify(men))
      if (men.board === 'Retransmisión') {
        // window.alert(JSON.stringify(men))
        this.mensjGame.push(men)
        if (bottom) {
          this.isAtBottom()
        }
      }
      if (toast === true) {
        if (men.send !== UserService.getUser().username) {
          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000)
        }
      }
    },
    /* loadUserConvert (parms) {
      var data = {
        c: 'chat',
        f: 'loadUserConvert',
        data: parms
      }
      this.$socket.emit('event', data, function (...callbacks) {
        var log = callbacks[1]
        if (log) {
          // this.mensjGame = log
          var menLast = ''
          const isToday = (someDate) => {
            const today = new Date()
            return someDate.getDate() === today.getDate() &&
              someDate.getMonth() === today.getMonth() &&
              someDate.getFullYear() === today.getFullYear()
          }
          for (var i = log.length - 1; i >= 0; i--) {
            if (menLast !== log[i].body && isToday(new Date(log[i].created)) && log[i].board === this.board._id) {
              this.recibeMensaje(log[i], false, false)
              menLast = log[i].body
            }
          }
          setTimeout(function () {
            Jquery('#chatConvertGame').animate({
              'scrollTop': Jquery('#chatConvertGame')[0].scrollHeight
            }, 'slow')
          }, 10)
        }
      }.bind(this))
    },*/
    checkImage (url) {
      return (url.match(/\.(jpeg|jpg|gif|png)$/) !== null)
    },
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultAvatar.png'
    },
    imageUrl (name) {
      return Store.get('serverDir') + '/uploads/' + name
    },
    resizeBoard () {
      document.body.dispatchEvent(new window.Event('chessground.resize'))
    },
    loadOtherUser (otherUser, next) {
      if (otherUser !== 'PC') {
        UserService.get(this, otherUser).then(function (response) {
          const dd = JSON.parse(response)
          const somedata = dd
          next(somedata)
        }, function (response) {
        // window.alert('mal')
        })
      } else {
        next({
          image: 'Droid-Robot-512.png'
        })
      }
    },
    /* recibeMensaje (men, bottom = false, toast = true) {
      var tabUser = men.send === UserService.getUser().username ? men.recibe : men.send
      var post = this.foundTab(tabUser)
      if (post) {
        this.tabs[post].men.push(men)
      } else {
        var tabConvert = {
          name: tabUser,
          idTab: tabUser,
          men: [men]
        }
        this.tabs.push(tabConvert)
        var active = this.active
        setTimeout(function () {
          this.active = active
        }.bind(this), 200)
      }
      if (bottom) {
        this.isAtBottom()
      }
      if (toast === true) {
        if (men.send !== UserService.getUser().username) {
          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 2000)
        }
      }
    },*/
    wellCome () {
      // window.alert('Bienvenido')
    },
    hasBoards () {
      var bBoards = false
      for (var i in this.boards) {
        if (this.boards[i].broadcast === 'true') {
          bBoards = true
          break
        }
      }
      return bBoards
    },
    deleteComment (pgn) {
      // pgn = pgn.replace(/\{(.*?)\}/gmu, '')
      // pgn = pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      // pgn = pgn.replace(/\{[^{}]*?%(?!clk)[^{}]*?\}/gmu, '')
      // Quita todos menos los clk
      pgn = pgn.replace(/\{(?![^{}]*clk)[^{}]*\}/gmu, '')
      // pgn = pgn.replace(/\{(\s\S.+?)\}/gmu, '')
      // window.alert(pgn)
      return pgn
    },
    cleanPGNContent (str) {
      return str.replace(/(\r?\n){2,}/g, '\n\n') // Mantener exactamente dos saltos entre partidas
        .replace(/\r?\n/g, (match, offset, string) => {
          const prevChar = string[offset - 1]
          const nextChar = string[offset + 1]
          // Si está entre partidas (dos saltos consecutivos), mantener el salto
          if (prevChar === '\n') {
            return match // No modificar, es parte de la separación entre partidas
          }
          // Si está dentro de los movimientos o comentarios
          if (prevChar === ']' || nextChar === '[') {
            return match // Mantener el salto de línea
          }
          return ' ' // Reemplazar con un espacio
        }).replace(/ {2,}/g, ' ') // Eliminar espacios dobles
    },
    prettyPgn (strParam) {
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*/
      // window.alert(str)
      // str = decodeURIComponent((str))
      var str = strParam
      try {
        // Intentar decodificar la cadena como UTF-8
        str = decodeURIComponent(escape(strParam))
      } catch (e) {
        str = strParam
      }
      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O') // .replace(/(1\-0|0\-1|1\/2\-1\/2)/g, ' * ').replace(/\s\d+/g, ' ').replace(/\$\d+/g, '').replace(/\?/g, '')
      str = this.cleanPGNContent(str)
      return str
    },
    update (arr, id, updatedData) {
      return arr.map((item) =>
        item.id === id ? { ...item, ...updatedData } : item
      )
    },
    notifyBoardUpdate (board) {
      if (board && this.hasBody(board.pgn)) {
        this.$broadcast('updateBoard', board)
      }
    },
    ensureFingerprintStore (propName) {
      if (!this.pgnFingerprints[propName]) {
        Vue.set(this.pgnFingerprints, propName, {})
      }
      return this.pgnFingerprints[propName]
    },
    getPgnFingerprint (pgn) {
      if (typeof pgn !== 'string') {
        if (pgn && typeof pgn === 'object' && typeof pgn.pgn === 'string') {
          pgn = pgn.pgn
        } else if (pgn === null || pgn === undefined) {
          pgn = ''
        } else {
          pgn = String(pgn)
        }
      }
      return pgn.replace(/\s+/g, ' ').trim()
    },
    syncBoards (propName, filesObj) {
      const fingerprintStore = this.ensureFingerprintStore(propName)
      const sourceBoards = Array.isArray(filesObj) ? filesObj : []

      if (!Array.isArray(this[propName]) || this[propName].length === 0) {
        this[propName] = this.clone(sourceBoards)
        if (sourceBoards.length > 0) {
          sourceBoards.forEach((board) => {
            if (board && board._id) {
              fingerprintStore[board._id] = this.getPgnFingerprint(board.pgn)
            }
          })
        }
        this.$nextTick(function () {
          if (Array.isArray(this[propName])) {
            // window.alert('notifyBoardUpdate 1' + this[propName]._id)
            this[propName].forEach((board) => this.notifyBoardUpdate(board))
          }
        }.bind(this))
        return
      }
      const target = this[propName]
      const nextIds = new Set()
      sourceBoards.forEach((newBoard, index) => {
        const currentBoard = target[index]
        const newFingerprint = this.getPgnFingerprint(newBoard && newBoard.pgn)

        if (newBoard && newBoard._id) {
          nextIds.add(newBoard._id)
        }

        if (!currentBoard) {
          Vue.set(target, index, newBoard)
          // window.alert('notifyBoardUpdate 2' + target[index]._id)
          this.notifyBoardUpdate(target[index])
          if (newBoard && newBoard._id) {
            fingerprintStore[newBoard._id] = newFingerprint
          }
          return
        }
        if (currentBoard._id !== newBoard._id) {
          if (currentBoard && currentBoard._id && fingerprintStore[currentBoard._id]) {
            delete fingerprintStore[currentBoard._id]
          }
          Vue.set(target, index, newBoard)
          // window.alert('notifyBoardUpdate 3' + target[index]._id)
          this.notifyBoardUpdate(target[index])
          if (newBoard && newBoard._id) {
            fingerprintStore[newBoard._id] = newFingerprint
          }
          return
        }

        const currentFingerprint = fingerprintStore[currentBoard._id]
        if (currentFingerprint === undefined || currentFingerprint !== newFingerprint || currentBoard.result !== newBoard.result) {
          var diff = this.getDifference(newBoard.pgn, target[index].pgn)
          if (diff.length > 0) {
            const updatedBoard = { ...currentBoard, ...newBoard, pgn: newBoard.pgn }
            Vue.set(target, index, updatedBoard)
            // window.alert('notifyBoardUpdate 4' + target[index]._id)
            this.notifyBoardUpdate(target[index])
          }
        }
        fingerprintStore[currentBoard._id] = newFingerprint
      })

      if (target.length > sourceBoards.length) {
        target.splice(sourceBoards.length)
      }

      Object.keys(fingerprintStore).forEach((id) => {
        if (!nextIds.has(id)) {
          delete fingerprintStore[id]
        }
      })
    },
    getDifference (string1, string2) {
      const differences = []
      const maxLength = Math.max(string1.length, string2.length)
      for (let i = 0; i < maxLength; i++) {
        const char1 = string1[i] || '' // Si falta el carácter, usa cadena vacía
        const char2 = string2[i] || '' // Si falta el carácter, usa cadena vacía
        if (char1 !== char2) {
          differences.push({
            position: i,
            char1: char1, // Marca con ∅ si no existe en la cadena original
            char2: char2  // Marca con ∅ si no existe en la cadena comparada
          })
          break // Solo queremos la primera diferencia
        }
      }
      return differences
    },
    parsePgnFiles (file, noFinish = false, number = 0, max = 40) {
      var newlineChar = '\r?\n'
      var filesObj = []
      file = this.prettyPgn(file)
      file = this.deleteComment(file)
      var lines = file.split(new RegExp(newlineChar))
      var pgntext = ''
      var state = 0
      var board = {}
      var headers = {}
      var hashCode = ''
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].length > 0) {
          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
            if (state === 1) {
              headers = this.parse_pgn_header(pgntext)
              hashCode = this.cyrb53(this.generateHeader(pgntext, true))
              board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '', result: headers['Result'], round: headers['Round'] }
              if ((noFinish === true || headers['Result'] === '*') /* && filesObj.length < max */) {
                // window.alert(pgntext)
                if (this.hasBody(pgntext)) {
                  if (filesObj.length < max) {
                    filesObj.push(board)
                  }
                }
              }
              pgntext = ''
            }
            state = 0
          } else state = 1
          if (state === 0) pgntext += lines[i] + '\n'
          else pgntext += lines[i] + ' '
        }
      }
      headers = this.parse_pgn_header(pgntext)
      hashCode = this.cyrb53(this.generateHeader(pgntext, true))
      board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '', result: headers['Result'], round: headers['Round'] }
      if ((noFinish === true || headers['Result'] === '*') && filesObj.length < max) {
        if (this.hasBody(pgntext)) {
          filesObj.push(board)
        }
      }
      if (number === 2) {
        if ((headers['Event'] && headers['Event'].length > 0) || (headers['Site'] && headers['Site'].length > 0)) {
          setTimeout(function () {
            this.syncBoards('boardFiles2', filesObj)
            this.boardFilesName2 = headers['Event'] + ' | ' + headers['Site'] + ' | ' + headers['Round'] + ' | ' + headers['Date']
          }.bind(this), 500)
        }
      } else if (number === 3) {
        if ((headers['Event'] && headers['Event'].length > 0) || (headers['Site'] && headers['Site'].length > 0)) {
          setTimeout(function () {
            this.syncBoards('boardFiles3', filesObj)
            this.boardFilesName3 = headers['Event'] + ' | ' + headers['Site'] + ' | ' + headers['Round'] + ' | ' + headers['Date']
          }.bind(this), 500)
        }
      } else if (number === 1) {
        if ((headers['Event'] && headers['Event'].length > 0) || (headers['Site'] && headers['Site'].length > 0)) {
          setTimeout(function () {
            // window.alert('¡Novedad!' + 'Se ha actualizado el torneo en vivo.' + 'info')
            // window.alert('Cargando torneo 1...' + filesObj.length)
            this.syncBoards('boardFiles', filesObj)
            this.boardFilesName = headers['Event'] + ' | ' + headers['Site'] + ' | ' + headers['Round'] + ' | ' + headers['Date']
          }.bind(this), 500)
        }
      }
      // filesObj = [...filesObj].reverse()
      // filesObj = filesObj.slice(0, max)
      return filesObj
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') && linea[0] !== '*'*/) {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    changePGNTextArea () {
      var idTextArea = document.getElementById('idTextAreaPGN')
      if (idTextArea && idTextArea.value !== 'none') {
        var pgnAux = idTextArea.value
        pgnAux = this.prettyPgn(pgnAux)
        pgnAux = this.deleteComment(pgnAux)
        this.myPGNValue = pgnAux
        // this.parsePgnFiles(idTextArea.value)
        // this.changePGN()
        var headers = this.parse_pgn_header(idTextArea.value)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          this.myFENValue = headers['FEN']
          // window.alert(headers['FEN'])
        }
        // window.alert('changePGNTextArea')
        // var turn = (this.chess.turn() === 'w') ? 'white' : 'black'
        var data = {
          c: 'board',
          f: 'move',
          data: {
            event: 'move',
            data: {
              urls: this.board.urls,
              pgn: this.myPGNValue,
              fen: this.myFENValue,
              idBoard: this.board._id,
              // turn: turn,
              times: {},
              user: UserService.getUser()
              /* move: {
                from: '',
                to: ''
              }*/
            }
          }
        }
        this.$socket.emit('event', data, function (...callbacks) {
          // console.log(callbacks)
        })
        // window.alert(idTextArea.value)
        // this.changeStateGame(idTextArea.value)
        idTextArea.value = ''
        var buttonLast = document.getElementById('pgnButtonslast')
        if (buttonLast) {
          buttonLast.click()
        }
      }
      // this.$dispatch('move', {pgn: this.myPGNValue})
      // }
    },
    openPGN (pgnText) {
      var output = document.getElementById('idTextAreaPGN')
      var idFEN = document.getElementById('myFENValue')
      output.value = pgnText
      idFEN.value = ''
      idFEN.textContent = ''
      idFEN.dispatchEvent(new window.Event('input'))
      output.dispatchEvent(new window.Event('change'))
      this.$broadcast('modal::close', 'some', 'pgnFilesModal')
      // this.torneoShow = false
      setTimeout(function () {
        document.getElementById('pgnButtonslast').click()
      }, 100)
    },
    cyrb53 (str, seed = 0) {
      let h1 = 0xdeadbeef ^ seed
      let h2 = 0x41c6ce57 ^ seed
      for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i)
        h1 = Math.imul(h1 ^ ch, 2654435761)
        h2 = Math.imul(h2 ^ ch, 1597334677)
      }
      h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909)
      h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909)
      return 4294967296 * (2097151 & h2) + (h1 >>> 0)
    },
    hashCode5 (string) {
      var hash = 5
      if (string.length === 5) {
        return hash
      }
      for (var a = 5; a < string.length; a++) {
        var ch = string.charCodeAt(a)
        hash = ((hash << 5) - hash) + ch
        hash = hash & hash
      }
      return Math.random()
    },
    hashCode (s) {
      var h = 0
      var l = s.length
      var i = 0
      if (l > 0) {
        while (i < l) {
          h = (h << 5) - h + s.charCodeAt(i++) | 0
        }
      }
      var hexString = h.toString(16)
      return hexString
    },
    getVideoTorneos (number) {
      const _self = this
      const url = `../../../static/torneos/livevideo${number}.txt`
      fetch(url)
        .then(response => {
          if (!response.ok) {
            // console.error(`Error ${response.status}: ${response.statusText}`)
            return
          }
          return response.text()
        })
        .then(responseText => {
          if (responseText) {
            if (number === 1) {
              _self.srcVideo1 = responseText
            } else if (number === 2) {
              _self.srcVideo2 = responseText
            } else if (number === 3) {
              _self.srcVideo3 = responseText
            }
          }
        })
        .catch(error => {
          console.error('Fetch error:', error)
        })
    },
    /* getVideoTorneos (number) {
      var _self = this
      var oReq = new window.XMLHttpRequest()
      oReq.open('GET', '../../../static/torneos/livevideo' + number + '.txt', true) // ../../../static/live.pgn', true)
      // oReq.setRequestHeader('Access-Control-Allow-Origin', '*')
      oReq.onreadystatechange = function () {
        if (oReq.readyState === 4) {
          if (oReq.status === 200) {
            // window.alert(this.responseText)
            if (number === 1) {
              _self.srcVideo1 = this.responseText
              // window.initDragElement()
              // window.initResizeElement()
            }
            if (number === 2) {
              _self.srcVideo2 = this.responseText
            }
            if (number === 3) {
              _self.srcVideo3 = this.responseText
            }
          }
        }
      }
      oReq.send()
    },*/
    getTorneos (number) {
      let ret = true
      const _self = this
      const url = `../../../static/torneos/live${number}.pgn`
      const options = {}
      if (number === 1 && lastDateTorneo1 !== null) {
        options.headers = { 'If-Modified-Since': lastDateTorneo1.toString() }
      } else if (number === 2 && lastDateTorneo2 !== null) {
        options.headers = { 'If-Modified-Since': lastDateTorneo2.toString() }
      } else if (number === 3 && lastDateTorneo3 !== null) {
        options.headers = { 'If-Modified-Since': lastDateTorneo3.toString() }
      }
      // window.alert('Cargando torneo ' + number + '...' + url)
      fetch(url, options)
        .then(response => {
          if (!response.ok) {
            // console.error(`Error ${response.status}: ${response.statusText}`)
            ret = false
            return
          }
          return response.text().then(responseText => {
            const mtime = new Date(response.headers.get('Last-Modified'))
            if (number === 1) {
              lastDateTorneo1 = mtime
              setTimeout(function () {
                _self.boardFiles1 = _self.parsePgnFiles(responseText, true, number)
              }, 200)
            } else if (number === 3) {
              lastDateTorneo3 = mtime
              setTimeout(function () {
                _self.boardFiles3 = _self.parsePgnFiles(responseText, true, number)
              }, 200)
            } else if (number === 2) {
              lastDateTorneo2 = mtime
              setTimeout(function () {
                _self.boardFiles2 = _self.parsePgnFiles(responseText, true, number)
              }, 200)
            }
          })
        })
        .catch(error => {
          console.error('Fetch error:', error)
          ret = false
        })
      return ret
    },
    loadAllData () {
      var data = {
        c: 'chat',
        f: 'getDataChat',
        data: {
          user: UserService.getUser()
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            // var logUser = callbacks[1].logUser
            // window.alert(logUser)
            // for (var i = 0; i < logUser.length; i++) {
              // if (logUser[i]) {
            // this.openTab({nickname: logUser[i]}, false)
            var parmsLoad = {
              // user: logUser[i],
              user: this.user,
              board: 'Retransmisión',
              range: {
                limit: 100,
                skip: 0
              }
            }
            this.loadUserConvert(parmsLoad, false)
              // }
            // }
            this.isAtBottom()
            this.boards = callbacks[1].boards
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    loadUserConvert (parms, show = true) {
      var data = {
        c: 'chat',
        f: 'loadUserConvert',
        data: parms
      }
      // window.alert('loadUserConvert')
      this.$socket.emit('event', data, function (...callbacks) {
        var log = callbacks[1]
        // window.alert(JSON.stringify(log))
        // this.mensjGame = []
        var menLast = ''
        if (log) {
          for (var i = log.length - 1; i >= 0; i--) {
            if (menLast !== log[i].body || menLast === '') {
              this.recibeMensaje(log[i], false, false)
              menLast = log[i].body
            }
          }
        }
        if (show) {
          this.isAtBottom()
        }
      }.bind(this))
    },
    activeWebcam () {
      this.toast('<span>No implement yet</span>', 2000)
    },
    inviteChessGame () {
      this.$broadcast('modal::open', 'inviteGame')
    },
    inviteChessGameDirect (user) {
      this.openTab(user)
      this.$broadcast('modal::open', 'inviteGame')
    },
    createdInviteGame (result) {
      if (result) {
        var invite = {
          type: 'invite',
          public: this.newboard.public,
          broadcast: false,
          all: false,
          club: UserService.getUser().club,
          time: this.newboard.time,
          incremento: this.newboard.incremento,
          recibe: this.active
        }
        // window.alert(JSON.stringify(invite))
        var userActive = UserService.getUser().username
        var bFound = false
        if (this.newboard.contrincante !== '') {
          for (var i in this.users) {
            if (this.users[i].nickname === this.newboard.contrincante) {
              userActive = this.users[i].nickname
              bFound = true
            }
          }
          if (bFound === false) {
          // window.alert('error')
            this.$broadcast('modal::close', 'some', 'inviteGame')
            return
          }
        }
        if (this.newboard.color === 'w') {
          invite.u1 = userActive
          invite.u2 = this.active
        } else {
          invite.u2 = userActive
          invite.u1 = this.active
        }
        var data = {
          c: 'board',
          f: 'inviteGame',
          data: {
            event: 'inviteGame',
            data: invite
          }
        }
        this.toast('<span>' + Vue.t('home.inviteSend') + '</span>', 2000)
        this.$socket.emit('event', data, function (...callbacks) {
          // console.log(callbacks)
        })
      }
      this.$broadcast('modal::close', 'some', 'inviteGame')
    }
  },
  ready () {
    /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    document.title = 'Mainchess - ' + this.$t('events.title')
  },
  beforeDestroy () {
    // window.alert('a otra cosa')
    clearInterval(intervalTorneos1)
  },
  created () {
    window.ground = null
    lastDateTorneo1 = null // new Date(new Date().setDate(new Date().getDate() - 1))
    lastDateTorneo2 = null // new Date(new Date().setDate(new Date().getDate() - 1))
    lastDateTorneo3 = null // new Date(new Date().setDate(new Date().getDate() - 1))
    clearInterval(intervalTorneos1)
    intervalTorneos1 = setInterval(function () {
      var x = document.getElementById('idTorneo1')
      if (/* this.boardFilesName.length > 0  && */ x !== null && x.style.display !== 'none') {
        if (this.getTorneos(1) === true) {
          this.getVideoTorneos(1)
        }
      }
      x = document.getElementById('idTorneo2')
      if (/* this.boardFilesName2.length > 0 && */ x !== null && x.style.display !== 'none') {
        if (this.getTorneos(2) === true) {
          this.getVideoTorneos(2)
        }
      }
      x = document.getElementById('idTorneo3')
      if (/* this.boardFilesName3.length > 0 && */ x !== null && x.style.display !== 'none') {
        if (this.getTorneos(3) === true) {
          this.getVideoTorneos(3)
        }
      }
    }.bind(this), 2000)
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    this.$nextTick(function () {
      this.active = 'boardVisorEvents'
      this.loadAllData()
      if (this.getTorneos(1) === true) {
        this.getVideoTorneos(1)
      }
      if (this.getTorneos(2) === true) {
        this.getVideoTorneos(2)
      }
      if (this.getTorneos(3) === true) {
        this.getVideoTorneos(3)
      }
    })
    // setTimeout(() => {
      // window.dragElement(document.getElementById('video1'))
    // }, 5000)
    this.$dispatch('userLoguin', 'show data')
  },
  mounted () {
    // window.initDragElement()
    // window.initResizeElement()
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?d0fb9370